import React from "react";
import { FormGroup } from "react-bootstrap";
import Rating from "react-rating";
import styles from "./Ratings.scss";

class Ratings extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.state = {
      rating: 0
    };
  }

  handleOnChange(value) {
    this.props.input.onChange(value);
    this.setState({ rating: value });
  }

  render() {
    const { text, emptyIcon, filledIcon } = this.props;

    return (
      <FormGroup className={styles.ratings}>
        <div className={styles.text}>{text}</div>
        <Rating
          emptySymbol={<img src={emptyIcon} className={styles.icon} />}
          fullSymbol={<img src={filledIcon} className={styles.icon} />}
          onChange={this.handleOnChange}
          initialRating={this.state.rating}
        />
      </FormGroup>
    );
  }
}

export default Ratings;



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Ratings.js